import { useContextTranslation } from '@core/i18n';
import { AccessibleSVG } from '@core/svg/AccessibleSVG';
/**
 * A padlock SVG icon
 */
export function UnlockVideo(props) {
    const { t } = useContextTranslation();
    return (<AccessibleSVG width="100%" height="100%" viewBox="0 0 24 24" {...props} fill="none" label={t('player:A stylized padlock icon')}>
      <circle cx="12.0004" cy="13.8002" r="7.2" stroke="white" strokeWidth="1.8"/>
      <path d="M17.3996 8.75961V7.96247C17.3996 4.7245 14.9819 2.09961 11.9996 2.09961C9.01727 2.09961 6.59961 4.7245 6.59961 7.96247V8.75961" stroke="white" strokeWidth="1.8"/>
      <path d="M14.0617 13.7998L11.0996 15.9375L11.0996 11.6621L14.0617 13.7998Z" fill="white" stroke="white" strokeWidth="1.8"/>
    </AccessibleSVG>);
}
